const linksNb = {
    appLinks: {
        ios: "https://apps.apple.com/it/app/nexi-business/id1292575968",
        android: "https://play.google.com/store/apps/details?id=it.nexi.merchant"
    },
    generalCondictions: 'https://www.nexi.it/content/dam/nexi/download/trasparenza/esercenti/condizioni-generali-nexi-business.pdf',
    transparency: "https://www.nexi.it/it/trasparenza",
    cookies: "https://www.nexi.it/it/cookie-policy",
    privacy: "https://www.nexi.it/content/dam/nexi/download/trasparenza/esercenti/informativa-privacy-nexi-business.pdf",
    portale_esercenti: "https://enterprise.nexiweb.com/registration/migration-to-laka?vat-number=" // NEXI-ENTERPRISE
}
const linksUci = {
    appLinks: {
        ios: "",
        android: ""
    },
    generalCondictions: 'https://www.nexi.it/content/dam/nexi/download/trasparenza/esercenti/condizioni-generali-nexi-business.pdf',
    transparency: "https://www.unicredit.it/it/info/trasparenzabancaria.html",
    privacy: "https://www.unicredit.it/it/info/privacy.html",
    portale_esercenti: "https://portale-esercenti.unicredit.it/XA-EPM-PF/home.iface"
}

const linksConfigReturn = () => {
    const bank = process.env.BANK
    switch (bank) {
        case 'NEXIBUSINESS':
            return linksNb;
        case 'UCI':
            return linksUci;
        default: return linksNb;
    }
}

const linksConfig = linksConfigReturn()
export default linksConfig;